// import React from "react";
// import '../styles/Footer.css'

// const Footer = () => {
//   return (
//     <footer className='footer_div'>© 2023 Copyright: PRIMAL GRID.</footer>
//   );
// };
// export default Footer;

import React from 'react'
import '../styles/Footer.css'
import { FaFacebookF } from 'react-icons/fa'
import { FiInstagram } from 'react-icons/fi'
import { AiFillBook, AiFillGithub, AiFillLinkedin, AiFillPhone } from 'react-icons/ai'


const Footer = () => {
  return (
    <footer>

      <div className="footer__logo__div">
        <a href="#" className='footer__logo__title'>PRIMAL GRID</a>
        <a href="#" className='footer__logo__tag'>An Online Interactive Demo</a>
      </div>

      <div className='footer__socials'>
        <a href="https://github.com/gsartoretti/PRIMAL"><AiFillGithub /></a>
        <a href="https://arxiv.org/abs/1809.03531"><AiFillBook /></a>
        <a href="https://primalgrid.netlify.app/contact"><AiFillPhone /></a>
      </div>

      <div className="footer__copyright">
        <small>© 2023 Copyright: PRIMAL GRID.</small>
      </div>

    </footer>
  )
}

export default Footer
